export default "__VITE_ASSET__DlFaqd7x__"